import React from 'react'

const iconPresets = {
  Facebook: {
    name: 'Facebook',
    viewBox: '0 0 16 16',
    paths: (
      <path
        d="M1 0C.5 0 0 .4 0 .9v14.2c0 .5.4.9.9.9h7.6V9.8h-2V7.4h2V5.6c0-2 1.3-3.2 3.2-3.2l1.8.1v2.2h-1.3c-1 0-1.2.5-1.2 1.2v1.5h2.4l-.3 2.4h-2V16h4c.5 0 .9-.4.9-.9V.9c0-.5-.4-.9-.9-.9H1z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    ),
  },
  Twitter: {
    name: 'Twitter',
    viewBox: '0 0 16 13',
    paths: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1.5c-.6.3-1.3.5-2 .6.8-.4 1.3-1 1.5-1.9-.6.4-1.3.7-2 .8C12.7.4 12 0 11 0A3.3 3.3 0 008 4 9.3 9.3 0 011 .6c-.3.5-.5 1-.5 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.2 3 2.7 3.2a3.3 3.3 0 01-1.5 0 3.3 3.3 0 003 2.4A6.6 6.6 0 010 11.5a9.3 9.3 0 0014.4-7.8v-.4c.6-.5 1.2-1 1.6-1.7z"
      />
    ),
  },
  LinkedIn: {
    name: 'LinkedIn',
    viewBox: '0 0 1024 1024',
    paths: (
      <path d="M928 0h-832c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 832h-128v-448h128v448zM320 320c-35.4 0-64-28.6-64-64s28.6-64 64-64c35.4 0 64 28.6 64 64s-28.6 64-64 64zM832 832h-128v-256c0-35.4-28.6-64-64-64s-64 28.6-64 64v256h-128v-448h128v79.4c26.4-36.2 66.8-79.4 112-79.4 79.6 0 144 71.6 144 160v288z" />
    ),
  },
  Instagram: {
    name: 'Instagram',
    viewBox: '0 0 24 24',
    paths: (
      <g>
        <path d="m12.004 5.838c-3.403 0-6.158 2.758-6.158 6.158 0 3.403 2.758 6.158 6.158 6.158 3.403 0 6.158-2.758 6.158-6.158 0-3.403-2.758-6.158-6.158-6.158zm0 10.155c-2.209 0-3.997-1.789-3.997-3.997s1.789-3.997 3.997-3.997 3.997 1.789 3.997 3.997c.001 2.208-1.788 3.997-3.997 3.997z" />
        <path d="m16.948.076c-2.208-.103-7.677-.098-9.887 0-1.942.091-3.655.56-5.036 1.941-2.308 2.308-2.013 5.418-2.013 9.979 0 4.668-.26 7.706 2.013 9.979 2.317 2.316 5.472 2.013 9.979 2.013 4.624 0 6.22.003 7.855-.63 2.223-.863 3.901-2.85 4.065-6.419.104-2.209.098-7.677 0-9.887-.198-4.213-2.459-6.768-6.976-6.976zm3.495 20.372c-1.513 1.513-3.612 1.378-8.468 1.378-5 0-7.005.074-8.468-1.393-1.685-1.677-1.38-4.37-1.38-8.453 0-5.525-.567-9.504 4.978-9.788 1.274-.045 1.649-.06 4.856-.06l.045.03c5.329 0 9.51-.558 9.761 4.986.057 1.265.07 1.645.07 4.847-.001 4.942.093 6.959-1.394 8.453z" />
        <circle cx="18.406" cy="5.595" r="1.439" />
      </g>
    ),
  },
  Arrow: {
    name: 'Arrow',
    viewBox: '0 0 20 13',
    paths: (
      <path d="M19.7 5.8L14.2.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.8 3.8H1c-.6 0-1 .4-1 1s.4 1 1 1h15.6l-3.8 3.8a1 1 0 000 1.4c.2.2.5.3.7.3s.5-.1.7-.3l5.5-5.5c.2-.2.3-.4.3-.7s-.1-.5-.3-.7z" />
    ),
  },
  Cross: {
    name: 'cross',
    viewBox: '0 0 24 24',
    paths: (
      <path d="M24 2.82353L21.1765 0L12 9.17647L2.82353 0L0 2.82353L9.17647 12L0 21.1765L2.82353 24L12 14.8235L21.1765 24L24 21.1765L14.8235 12L24 2.82353Z" />
    ),
  },
  Phone: {
    name: 'Phone',
    viewBox: '0 0 21 20',
    paths: (
      <path d="M5.1 8.6c2.2 3.5 3.6 4.9 7.2 7l2.9-2.8c1.5.4 3.3.9 4.8.9.5 0 1 .5 1 .9V19c0 .5-.5 1-1 1C7.6 20 .4 13 0 1c0-.5.5-1 1-1h4.9c.5 0 1 .5 1.2.8-.2 1.6.5 3.6.9 5L5.1 8.6z" />
    ),
  },
  Chat: {
    name: 'Chat',
    viewBox: '0 0 20 19',
    paths: (
      <path d="M4 0h12a4 4 0 0 1 4 4v5.351a4 4 0 0 1-4 4h-3.062A5 5 0 0 0 9.6 14.63L5.56 18.252a.5.5 0 0 1-.834-.372v-3.584a.945.945 0 0 0-.945-.945A3.78 3.78 0 0 1 0 9.571V4a4 4 0 0 1 4-4z" />
    ),
  },
  Chevron: {
    name: 'Chevron',
    viewBox: '0 0 14 8',
    paths: (
      <path d="M7 7.8c-.4 0-.8-.1-1.1-.4L.3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0L7 5.6 12.3.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L8.1 7.4c-.3.2-.7.4-1.1.4z" />
    ),
  },
  Check: {
    name: 'check',
    viewBox: '0 0 1200 1000',
    paths: (
      <path d="M134.55 492.483l-111.562 111.231 373.198 374.31 841.133-843.64-111.562-111.231-729.571 731.745z" />
    ),
  },
  Play: {
    name: 'play',
    viewBox: '0 0 11 14',
    paths: <path d="M10.5005 7L0.562046 0.437954V13.562L10.5005 7Z" />,
  },
  Magnify: {
    name: 'Magnify',
    viewBox: '0 0 24 24',
    paths: (
      <path d="M14.1262 14.1263C16.7443 11.5082 16.7443 7.26337 14.1262 4.64526C11.5081 2.02714 7.26333 2.02714 4.64522 4.64526C2.02711 7.26337 2.02711 11.5082 4.64522 14.1263C7.26333 16.7444 11.5081 16.7444 14.1262 14.1263ZM15.0071 16.9033C11.3308 19.6595 6.09248 19.3659 2.74901 16.0225C-0.916336 12.3571 -0.916336 6.41439 2.74901 2.74902C6.41435 -0.916352 12.3571 -0.916327 16.0224 2.74902C19.3659 6.09246 19.6595 11.3308 16.9033 15.0071L23.6073 21.7111C24.1309 22.2347 24.1309 23.0836 23.6073 23.6073C23.0837 24.1309 22.2347 24.1309 21.7111 23.6073L15.0071 16.9033V16.9033Z" />
    ),
  },
  Clock: {
    name: 'Clock',
    viewBox: '0 0 22 22',
    paths: (
      <>
        <circle cx="11" cy="11" r="10" stroke="#000" strokeWidth="2" />
        <path d="M10 5v6.818L14 15" stroke="#000" strokeWidth="2" />
      </>
    ),
  },
  Website: {
    name: 'Website',
    viewBox: '0 0 512 512',
    paths: (
      <path d="m437.335 75.082c-100.1-100.102-262.136-100.118-362.252 0-100.103 100.102-100.118 262.136 0 362.253 100.1 100.102 262.136 100.117 362.252 0 100.103-100.102 100.117-262.136 0-362.253zm-10.706 325.739c-11.968-10.702-24.77-20.173-38.264-28.335 8.919-30.809 14.203-64.712 15.452-99.954h75.309c-3.405 47.503-21.657 92.064-52.497 128.289zm-393.338-128.289h75.309c1.249 35.242 6.533 69.145 15.452 99.954-13.494 8.162-26.296 17.633-38.264 28.335-30.84-36.225-49.091-80.786-52.497-128.289zm52.498-160.936c11.968 10.702 24.77 20.173 38.264 28.335-8.919 30.809-14.203 64.712-15.452 99.954h-75.31c3.406-47.502 21.657-92.063 52.498-128.289zm154.097 31.709c-26.622-1.904-52.291-8.461-76.088-19.278 13.84-35.639 39.354-78.384 76.088-88.977zm0 32.708v63.873h-98.625c1.13-29.812 5.354-58.439 12.379-84.632 27.043 11.822 56.127 18.882 86.246 20.759zm0 96.519v63.873c-30.119 1.877-59.203 8.937-86.246 20.759-7.025-26.193-11.249-54.82-12.379-84.632zm0 96.581v108.254c-36.732-10.593-62.246-53.333-76.088-88.976 23.797-10.817 49.466-17.374 76.088-19.278zm32.646 0c26.622 1.904 52.291 8.461 76.088 19.278-13.841 35.64-39.354 78.383-76.088 88.976zm0-32.708v-63.873h98.625c-1.13 29.812-5.354 58.439-12.379 84.632-27.043-11.822-56.127-18.882-86.246-20.759zm0-96.519v-63.873c30.119-1.877 59.203-8.937 86.246-20.759 7.025 26.193 11.249 54.82 12.379 84.632zm0-96.581v-108.254c36.734 10.593 62.248 53.338 76.088 88.977-23.797 10.816-49.466 17.373-76.088 19.277zm73.32-91.957c20.895 9.15 40.389 21.557 57.864 36.951-8.318 7.334-17.095 13.984-26.26 19.931-8.139-20.152-18.536-39.736-31.604-56.882zm-210.891 56.882c-9.165-5.947-17.941-12.597-26.26-19.931 17.475-15.394 36.969-27.801 57.864-36.951-13.068 17.148-23.465 36.732-31.604 56.882zm.001 295.958c8.138 20.151 18.537 39.736 31.604 56.882-20.895-9.15-40.389-21.557-57.864-36.951 8.318-7.334 17.095-13.984 26.26-19.931zm242.494 0c9.165 5.947 17.942 12.597 26.26 19.93-17.475 15.394-36.969 27.801-57.864 36.951 13.067-17.144 23.465-36.729 31.604-56.881zm26.362-164.302c-1.249-35.242-6.533-69.146-15.452-99.954 13.494-8.162 26.295-17.633 38.264-28.335 30.84 36.225 49.091 80.786 52.497 128.289z" />
    ),
  },
}

export default iconPresets
